export default [
  {
    key: 'agent_ids',
    value: 1,
    label: 'アライアンス名',
    rules: {},
    name: 'agentIds',
    as: 'checkbox',
    options: [],
    checked: [],
    disabled: 1,
  },
  {
    key: 'email',
    value: '',
    label: 'メールアドレス',
    rules: { required: true, email: true },
    name: 'email',
    as: 'input',
  },
  {
    key: 'account_name',
    value: '',
    label: 'ユーザ名',
    rules: { required: true, scope: { min: 1, max: 16 } },
    name: 'accountName',
    as: 'input',
  },
  {
    key: 'password',
    value: '',
    label: 'パスワード',
    rules: { confirmed: 'passwordConfirm', password: true, required: true },
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'パスワード(確認）',
    rules: { required: true, confirmed: 'password', password: true },
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'gender',
    value: 1,
    label: '性別',
    rules: {},
    name: 'gender',
    as: 'radio',
    options: [],
    checked: '',
  },
  {
    key: 'birthday',
    value: '1990-01-01',
    label: '生年月日',
    rules: {},
    name: 'birthday',
    as: 'datepicker',
  },
  {
    key: 'height',
    value: 170,
    label: '身長(cm)',
    rules: {},
    name: 'height',
    as: 'input',
    type: 'number',
    class: 'width-210',
  },
  {
    key: 'athlete',
    value: 0,
    label: 'アスリートモード',
    rules: {},
    name: 'athlete',
    as: 'radio',
    options: [],
    checked: '',
  },
]
